export default __webpack_public_path__ + "static/media/AR.4f9d478d.pdf";